var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#13886C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 13,
    width: 26,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 13,
    width: 26,
    height: 26,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9362 35.2349H27.982C27.3469 34.6426 26.9321 33.9654 26.6746 33.2629H21.3281C21.0706 33.9654 20.6557 34.6426 20.0207 35.2349H19.0671C18.5284 35.2349 18.0918 35.6715 18.0918 36.2101C18.0918 36.3566 18.2105 36.4754 18.357 36.4754H29.6464C29.7929 36.4754 29.9116 36.3566 29.9116 36.2101C29.9115 35.6716 29.4748 35.2349 28.9362 35.2349Z",
    fill: "#E8F6F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8328 15.5249H12.17C11.5974 15.5249 11 15.9868 11 16.6949V31.5232C11 32.1787 11.531 32.7098 12.1866 32.7098H35.8327C36.4827 32.7098 37 32.187 37 31.5426V16.6949C36.9999 16.0504 36.4827 15.5249 35.8328 15.5249V15.5249ZM23.6846 31.8247C23.3969 31.8247 23.1646 31.5923 23.1646 31.3047C23.1646 31.017 23.3969 30.7847 23.6846 30.7847C23.9722 30.7847 24.2073 31.017 24.2073 31.3047C24.2073 31.5924 23.9722 31.8247 23.6846 31.8247ZM35.6169 29.8996H12.3828V16.9078H35.6168V29.8995H35.6169V29.8996Z",
    fill: "#E8F6F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9997 28.0049C27.2774 28.0049 30.0821 25.3357 31.2327 24.0634C31.5729 23.6872 31.5729 23.1174 31.2327 22.7412C30.0821 21.4689 27.2774 18.8025 23.9997 18.8025C20.7221 18.8025 17.9174 21.4689 16.764 22.7412C16.4237 23.1174 16.4237 23.6872 16.764 24.0634C17.9174 25.3357 20.7221 28.0049 23.9997 28.0049ZM23.9997 19.7844C25.9995 19.7844 27.6176 21.4025 27.6176 23.4023C27.6176 25.4021 25.9995 27.0201 23.9997 27.0201C21.9999 27.0201 20.3818 25.4021 20.3818 23.4023C20.3818 21.4025 21.9999 19.7844 23.9997 19.7844Z",
    fill: "#E8F6F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0001 25.4132C25.112 25.4132 26.011 24.5143 26.011 23.4023C26.011 23.1672 25.9667 22.9404 25.8948 22.7329C25.7399 23.0095 25.4467 23.1976 25.1065 23.1976C24.6087 23.1976 24.2048 22.7938 24.2048 22.2959C24.2048 21.9558 24.3929 21.6625 24.6695 21.5077C24.4621 21.4358 24.2353 21.3915 24.0001 21.3915C22.8882 21.3915 21.9893 22.2904 21.9893 23.4024C21.9893 24.5143 22.8882 25.4132 24.0001 25.4132L24.0001 25.4132Z",
    fill: "#E8F6F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.b9c400c169d8bcdd03c4bd0fe204644d.svg";
export { ForwardRef as ReactComponent };